import type {
  MainNavigationBlock,
  SecondaryNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';

export interface DisplayVerticalOptions {
  casinoNonAuth: boolean;
  sportsNonAuth: boolean;
}

export function checkUrl(urls: string[], pathname: string): boolean {
  return urls.some((item: string) => pathname.startsWith(item));
}

export const displayVertical = (
  url: string,
  { casinoNonAuth, sportsNonAuth }: DisplayVerticalOptions
) => {
  if (!url) return true;

  switch (true) {
    case url.includes('/casino/'):
      return casinoNonAuth;
    case url.includes('/sports/'):
      return sportsNonAuth;
    default:
      return true;
  }
};

export const filterMainNavItems = (
  navigation: MainNavigationBlock[],
  { casinoNonAuth, sportsNonAuth }: DisplayVerticalOptions
) => {
  if (!navigation?.length) return [];

  return navigation.filter((item) =>
    displayVertical(item.url || '', {
      casinoNonAuth,
      sportsNonAuth
    })
  );
};

export const filterSecondaryNavItems = (
  navigation: SecondaryNavigationBlock[],
  pathname: string
) => {
  if (!navigation?.length) return [];

  // eslint-disable-next-line @typescript-eslint/naming-convention
  return navigation.filter(({ show_on_urls, hide_on_urls }) => {
    if (show_on_urls?.length) return checkUrl(show_on_urls, pathname);
    if (hide_on_urls?.length) return !checkUrl(hide_on_urls, pathname);

    return true;
  });
};
